import { ResultsPanel } from "@omni/components/components/Search/SearchBar/components/ResultsPanel/resultsPanel";
import { SearchBar } from "@omni/components/components/Search/SearchBar/searchBar";
import { useGranite } from "@omni/components/redux/modules/value/translations/translations.provider";
import { cn } from "@omni/utils/styles";

export const ResultsPanelComponent = () => {
    const { t } = useGranite();
    const { autocompleteState } = SearchBar.useContext();

    return (
        <>
            <ResultsPanel.CloseButton />
            <ResultsPanel.Panel
                className={cn(
                    "tw:mt-4 tw:bg-white tw:flex tw:flex-col tw:border-t tw:border-divider tw:pt-4 tw:overflow-auto tw:h-full tw:pb-8",
                    "tw:lg:grid tw:lg:gap-4 tw:lg:grid-cols-[9fr_16fr] tw:lg:border-none tw:pt-0 tw:overflow-visible tw:h-auto tw:pb-0"
                )}
            >
                <ResultsPanel.NoResults />
                <ResultsPanel.Results>
                    <div className={cn("tw:min-w-0")}>
                        <ResultsPanel.Results.RecentSearches>
                            <div
                                className={cn(
                                    "tw:text-primary tw:flex tw:justify-between tw:content-center"
                                )}
                            >
                                <div className={"tw:font-bold tw:py-2 tw:m-0"}>
                                    {t(
                                        "searchBox.panel.recentSearches.header.title"
                                    )}
                                </div>
                                <ResultsPanel.Results.RecentSearches.ClearButton />
                            </div>
                            <ResultsPanel.Results.RecentSearches.Items>
                                <ResultsPanel.Results.RecentSearches.Item />
                            </ResultsPanel.Results.RecentSearches.Items>
                        </ResultsPanel.Results.RecentSearches>
                        <ResultsPanel.Results.QuerySuggestions>
                            <div
                                className={cn(
                                    "tw:text-primary tw:font-bold tw:py-2 tw:m-0"
                                )}
                            >
                                {t(
                                    "searchBox.panel.querySuggestions.header.title"
                                )}
                            </div>
                            <ResultsPanel.Results.QuerySuggestions.Items>
                                <ResultsPanel.Results.QuerySuggestions.Item />
                            </ResultsPanel.Results.QuerySuggestions.Items>
                        </ResultsPanel.Results.QuerySuggestions>
                        <ResultsPanel.Results.ContentPages>
                            <div
                                className={cn(
                                    "tw:text-primary tw:font-bold tw:py-2 tw:m-0"
                                )}
                            >
                                {t("searchBox.panel.contentPages.header.title")}
                            </div>
                            <ResultsPanel.Results.ContentPages.Items>
                                <ResultsPanel.Results.ContentPages.Item />
                            </ResultsPanel.Results.ContentPages.Items>
                        </ResultsPanel.Results.ContentPages>
                    </div>
                    <div className={cn("tw:min-w-0")}>
                        <ResultsPanel.Results.Products>
                            <div
                                className={cn(
                                    "tw:text-primary tw:flex tw:justify-between tw:content-center"
                                )}
                            >
                                <div className={"tw:font-bold tw:py-2 tw:m-0"}>
                                    {autocompleteState?.query?.length === 0
                                        ? t(
                                              "searchBox.panel.products.header.title.emptyQuery"
                                          )
                                        : t(
                                              "searchBox.panel.products.header.title.querying"
                                          )}
                                </div>
                                <ResultsPanel.Results.Products.ShowAllButton
                                    color={"link"}
                                    className={cn(
                                        "tw:py-2 tw:px-0 tw:text-primary"
                                    )}
                                />
                            </div>
                            <ResultsPanel.Results.Products.Items>
                                <ResultsPanel.Results.Products.Item />
                            </ResultsPanel.Results.Products.Items>
                        </ResultsPanel.Results.Products>
                    </div>
                </ResultsPanel.Results>
            </ResultsPanel.Panel>
        </>
    );
};
